export default __webpack_public_path__ + "static/media/jeremy-yap.163ea18a.jpg";